import React from 'react';

import classes from './Header.css';
import Logo from '../Logo/Logo';

const header = ( props ) => (
    <header className={classes.Header}>
        <div className={classes.Logo}>
            <Logo />
        </div>
        <div className={classes.Heading}>
            DELIVERY MANAGER
        </div>
    </header>
);

export default header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js